import { render, staticRenderFns } from "./CartsForm.vue?vue&type=template&id=1210c53d"
import script from "./CartsForm.vue?vue&type=script&lang=js"
export * from "./CartsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports